import React from "react";
import Imgix from "react-imgix";
import Link from "gatsby-link";
import Icon from "./Icon";

class FooterMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mapLink: "/live-downtown/virtual-tour/"
    };
  }

  componentDidMount() {
    // Initialize MapBox geocoding
    // const mbxGeocoding = require("@mapbox/mapbox-sdk/services/geocoding");
    // const geocodingClient = mbxGeocoding({
    //   accessToken:
    //     "pk.eyJ1IjoiamVmZnJvY2siLCJhIjoiNTdXNTd1byJ9.4qZ2-GvdI23-i2-0l0S5Wg"
    // });

    // // Request lat/lng for venueAddress and build link string
    // var that = this;
    // if (this.props.address) {
    //   geocodingClient
    //     .forwardGeocode({
    //       query: this.props.address
    //     })
    //     .send()
    //     .then(response => {
    //       const match = response.body;
    //       const latitude = match.features[0].center[0];
    //       const longitude = match.features[0].center[1];

    //       let mapLink = "/downtown-map/?lat=" + latitude + "&lng=" + longitude;
    //       mapLink = mapLink + "&filter=attraction";
    //       that.setState({ mapLink: mapLink });
    //     });
    // } else {
    //   that.setState({ mapLink: "/downtown-map/?filter=attraction" });
    // }
  }

  render() {
    const {
      text1 = "Find Out Where to Live, Eat & Stay Nearby",
      text2 = "Check Out the Downtown Map"
    } = this.props;

    return (
      <Link
        to={this.state.mapLink}
        className="footer-map relative flex flex-column justify-center-l items-center-l w-100"
      >
        <div className="footer-map__info-container relative z-1 bg-dark flex flex-column justify-between flex-row-l w-100 mw-1060">
          <div>
            <p className="p-emphasis ttu white mb0 tc tl-l">{text1}</p>
            <p className="h-5 ttu grey1 mb0 tc tl-l">{text2}</p>
          </div>
          <div className="flex items-center justify-center">
            <Icon
              path="icon-18-food-and-drink"
              height="17"
              width="17"
              className="ml1"
            />
            <Icon path="icon-18-venue" height="17" width="17" className="ml1" />
            <Icon
              path="icon-26-parking"
              height="17"
              width="17"
              className="ml1"
            />
            <Icon path="arrow-right" height="18" width="32" className="ml1" />
          </div>
        </div>
        <Imgix
          src={require("../../assets/images/map-bg.gif")}
          className="footer-map__image bg-grey1  absolute left-0 bottom-0 bg-center image-cover mb0 w-100"
          imgixParams={{
            "max-w": "2732",
            auto: ["compress"],
            crop: "focalpoint"
          }}
          htmlAttributes={{
            alt: "Map of Downtown Richmond"
          }}
        />
      </Link>
    );
  }
}

export default FooterMap;



// WEBPACK FOOTER //
// ./src/components/FooterMap.js